module.exports = __webpack_public_path__ + "img/logo.cbc46293.png";